import React from "react";
import { AppLayOut } from "../../components/layout/AppLayOut";
import BackButton from "../../components/backbutton/BackButton";

const OffersPage = () => {
  return (
    <AppLayOut>
      {" "}
      <BackButton />
      <div>Offers</div>
    </AppLayOut>
  );
};

export default OffersPage;
